import { render, staticRenderFns } from "./ClientListItem.vue?vue&type=template&id=96c696e2&scoped=true&"
import script from "./ClientListItem.vue?vue&type=script&lang=js&"
export * from "./ClientListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c696e2",
  null
  
)

export default component.exports